// extracted by mini-css-extract-plugin
module.exports = {"before-after-slider__delimiter":"OurworksPage_before-after-slider__delimiter__38QR6","our-works":"OurworksPage_our-works__Kmedi"};